export const s3UploadOptions = (file, signedRequestObj) => {
  const options = {
    url: signedRequestObj.url,
    policy: signedRequestObj.policy,
    success_action_status: signedRequestObj.success_action_status,
    credential: signedRequestObj['x-amz-credential'],
    signature: signedRequestObj['x-amz-signature'],
    algorithm: signedRequestObj['x-amz-algorithm'],
    date: signedRequestObj['x-amz-date'],
    key: signedRequestObj.key,
    filename: signedRequestObj.filename,
    contentType: signedRequestObj['Content-Type'],
    formData: new FormData(),
    full_url: signedRequestObj.url + signedRequestObj.key,
    file,
    provider: 's3',
  };

  options.formData.append('key', options.key);
  options.formData.append('acl', 'public-read');
  options.formData.append('Content-Type', options.contentType);
  options.formData.append('success_action_status', options.success_action_status);
  options.formData.append('x-amz-credential', options.credential);
  options.formData.append('x-amz-signature', options.signature);
  options.formData.append('x-amz-algorithm', options.algorithm);
  options.formData.append('x-amz-date', options.date);
  options.formData.append('policy', options.policy);
  options.formData.append('file', options.file);

  return options;
};

export const gcsUploadOptions = (file, signedRequestObj) => {
  const options = {
    url: signedRequestObj.url,
    contentType: signedRequestObj.contentType,
    expires: signedRequestObj.signature_params.expires,
    googleAccessId: signedRequestObj.signature_params.GoogleAccessId,
    signature: signedRequestObj.signature,
    filename: signedRequestObj.filename,
    policy: signedRequestObj.policy,
    bucket: signedRequestObj.bucket,
    path: signedRequestObj.path,
    full_url: signedRequestObj.full_url,
    formData: new FormData(),
    file,
    provider: 'gcs',
  };

  options.formData.append('signature', options.signature);
  options.formData.append('key', options.path);
  options.formData.append('policy', options.policy);
  options.formData.append('Content-Type', options.contentType);
  options.formData.append('Content-Length', file.size || 50000000);
  options.formData.append('GoogleAccessId', options.googleAccessId);
  options.formData.append('bucket', options.bucket);
  options.formData.append('acl', 'public-read');
  options.formData.append('file', options.file);

  return options;
};
